// extracted by mini-css-extract-plugin
module.exports = {"club-carousel--container":"ClubFeatureCarousel_club-carousel--container__YuhRM","club-carousel--item":"ClubFeatureCarousel_club-carousel--item__qh_s0"};